import React from 'react'

const LeavesAnimation = () => {
  return (
    <div className='leaves'>
      <img style={{ '--i':2 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':4 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':3 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':5 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':8 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':7 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':1 }} className='leafpng' src='./assets/oak leaf.png'/>
      <img style={{ '--i':6 }} className='leafpng' src='./assets/oak leaf.png'/>
    </div>
  )
}

export default LeavesAnimation